import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetExpertProfile($id: ID!, $partnerId: ID!) {
    chat(id: $id) {
      id
      partner {
        id
        name
      }
      expert {
        id
        name
        photoUrl
        languages
        partners(partnerId: $partnerId) {
          edges {
            id
            node {
              id
            }
            bio
            rating
            joinedAt
          }
        }
      }
    }
  }
`);
